import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcArchiveDispensary = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_38_106635)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M12.25 4.66699V12.2503H1.75V4.66699",
					stroke: "#828599",
					strokeWidth: 1.25,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.4166 1.75H0.583313V4.66667H13.4166V1.75Z",
					stroke: "#828599",
					strokeWidth: 1.25,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.83331 7H8.16665",
					stroke: "#828599",
					strokeWidth: 1.25,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_38_106635",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgIcArchiveDispensary);
export default ForwardRef;
